import styled from "styled-components";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import MainMenu from "./MainMenu";
import AboutUs from "./AboutUs";
import Contact from "./Contact";
import OurCompanies from "./OurCompanies";
import { i18n } from "../translate/i18n";
import "../styles/tab-menu.css";

export default function Menu() {
  return (
    <Container>
      <Tabs>
        <TabList>
          <Tab>{i18n.t("menu_titles.main_menu")}</Tab>
          <Tab>{i18n.t("menu_titles.about_us")}</Tab>
          <Tab>{i18n.t("menu_titles.contact")}</Tab>
          <Tab>{i18n.t("menu_titles.our_companies")}</Tab>
        </TabList>

        <TabPanel>
          <MainMenu />
        </TabPanel>
        <TabPanel>
          <AboutUs />
        </TabPanel>
        <TabPanel>
          <Contact />
        </TabPanel>
        <TabPanel>
          <OurCompanies />
        </TabPanel>
      </Tabs>
    </Container>
  );
}

const Container = styled.div`
  margin: 0 400px;
  font-size: 12px;
  font-family: Arial, Helvetica, sans-serif;
  color: #ffffff;

  @media (max-width: 1600px) {
    margin: 0 300px;
  }

  @media (max-width: 1400px) {
    margin: 0 200px;
  }

  @media (max-width: 1200px) {
    margin: 0 100px;
  }
`;
